export enum SurveyValues {
    CUSTOM_SURVEY = '0',
    CONCEPT_TESTING = '2',
    PACK_TESTING = '3',
    MAXDIFF = '1',
    BRAND_HEALTH = '6',
    COMMS_PRE_TESTING = '4',
    COMMS_POST_TESTING = '5',
    AD_REVIEW = '16',
}

export const SURVEY_OPTIONS = [
    {
        value: SurveyValues.CUSTOM_SURVEY,
        label: 'Custom survey',
    },
    {
        value: SurveyValues.CONCEPT_TESTING,
        label: 'Concept testing'
    },
    {
        value: SurveyValues.PACK_TESTING,
        label: 'Pack testing'
    },
    {
        value: SurveyValues.MAXDIFF,
        label: 'Maxdiff'
    },
    {
        value: SurveyValues.BRAND_HEALTH,
        label: 'Brand health'
    },
    {
        value: SurveyValues.COMMS_PRE_TESTING,
        label: 'Comms pre testing'
    },
    {
        value: SurveyValues.COMMS_POST_TESTING,
        label: 'Comms post testing'
    }
];

export const AD_REVIEW_SURVEY_OPTION = {
    value: SurveyValues.AD_REVIEW,
    label: 'AdReview'
};
